import type { CaseyReferralData } from "./types";

const EMAIL_SHAPED = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

/**
 * An attorney's name fit to show a client, or null. `attorney_name` falls back
 * to the account's email when no display name is set, and an email is not a
 * name.
 */
export const attorneyLabel = (
  name: string | null | undefined
): string | null => {
  const clean = (name ?? "").trim();
  return clean && !EMAIL_SHAPED.test(clean) ? clean : null;
};

/**
 * Who answers instead of Casey: the backend's `who` ("Dana Reeves at Reeves
 * Immigration", or the firm alone, or "your legal team"). Rebuilt the same
 * way for referrals saved before the field existed, so a missing name never
 * leaves "for  at Reeves Immigration".
 */
export const referralWho = (
  data: Partial<CaseyReferralData> | null | undefined
): string => {
  const who = (data?.who ?? "").trim();
  if (who) return who;
  const attorney = attorneyLabel(data?.attorney_name);
  const firm = (data?.law_firm_name ?? "").trim() || null;
  if (attorney) return firm ? `${attorney} at ${firm}` : attorney;
  return firm ?? "your legal team";
};
